<div class="wheel-container" #wrapper data-testid="wheel-container">
  <canvas #wheelCanvas class="canvas" data-testid="wheel-canvas" (click)="setData($event)"> </canvas>
</div>
